module.exports = __webpack_public_path__ + "static/media/ex2.d64d65aa.jpg";